<!-- titulo -->
<section class="flex mb-8">
    <div class="flex-1 flex flex-col">
        <span class="span1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
            Dispositivos
        </span>
        <span class="text-neutral-600 text-sm font-['Inter'] leading-tight">
            Estás visualizando toda la información disponible.
        </span>
    </div>
    <div class="flex gap-2 items-center">
        <div class="relative">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <img class="w-6 h-6 text-gray-500" src="../../../assets/img/ic-search.svg" />
            </div>
            <input [formControl]="filterControl" type="text" placeholder="Buscar" class="h-[36px] w-[256px] bg-gray-50 border-2 border-stone-400 text-gray-900 text-sm rounded-lg block ps-10">
        </div>
        <button class="h-[36px] flex items-center gap-1 bg-indigo-500 text-white px-4 rounded-lg shadow hover:bg-indigo-600" (click)="openFilters()">
            <img class="w-6 h-6" src="../../../assets/img/ic-filter.svg" />
            Filtrar
        </button>
    </div>
</section>

<!-- pseudo tabla -->
<!-- header -->
<section class="h-[48px] grid grid-cols-7 bg-white rounded-lg justify-items-center py-2 text-neutral-600 font-semibold text-sm mb-6">
    <div class="celda-centrada border-r">
        <div class="flex items-center cursor-pointer" (click)="sort('type')">
            Tipo
            <div class="ml-2 flex flex-col gap-[2px] ">
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg" [class.opacity-20]="isSortedBy('type', sortDirectionEnum.DESC)"/>
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg" [class.opacity-20]="isSortedBy('type', sortDirectionEnum.ASC)" />
            </div>
        </div>
    </div>
    <div class="celda-centrada border-r">
        <div class="flex items-center cursor-pointer" (click)="sort('merchant_name')">
            Comercio
            <div class="ml-2 flex flex-col gap-[2px]">
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg" [class.opacity-20]="isSortedBy('merchant_name', sortDirectionEnum.DESC)"/>
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg" [class.opacity-20]="isSortedBy('merchant_name', sortDirectionEnum.ASC)"/>
            </div>
        </div>
    </div>
    <div  class="celda-centrada border-r">
        <div class="flex items-center cursor-pointer" (click)="sort('alias')">
            Dispositivo
            <div class="ml-2 flex flex-col gap-[2px]">
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg" [class.opacity-20]="isSortedBy('alias', sortDirectionEnum.DESC)"/>
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg" [class.opacity-20]="isSortedBy('alias', sortDirectionEnum.ASC)"/>
            </div>
        </div>
    </div>
    <div class="celda-centrada border-r">
        <div class="flex items-center cursor-pointer" (click)="sort('lsn')">
            Serial
            <div class="ml-2 flex flex-col gap-[2px]">
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg" [class.opacity-20]="isSortedBy('lsn', sortDirectionEnum.DESC)"/>
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg" [class.opacity-20]="isSortedBy('lsn', sortDirectionEnum.ASC)"/>
            </div>
        </div>
    </div>
    <div class="celda-centrada border-r">
        <div class="flex items-center cursor-pointer" (click)="sort('created_at_time_zone')">
            Activación
            <div class="ml-2 flex flex-col gap-[2px]">
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg" [class.opacity-20]="isSortedBy('created_at_time_zone', sortDirectionEnum.DESC)"/>
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg" [class.opacity-20]="isSortedBy('created_at_time_zone', sortDirectionEnum.ASC)"/>
            </div>
        </div>
    </div>
    <div class="celda-centrada border-r">
        <div class="flex items-center cursor-pointer" (click)="sort('updated_at_time_zone')">
            Actualización
            <div class="ml-2 flex flex-col gap-[2px]">
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg" [class.opacity-20]="isSortedBy('updated_at_time_zone', sortDirectionEnum.DESC)"/>
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg" [class.opacity-20]="isSortedBy('updated_at_time_zone', sortDirectionEnum.ASC)"/>
            </div>
        </div>
    </div>
    <div class="celda-centrada">
        <div class="flex items-center cursor-pointer" (click)="sort('status')">
            Estado
            <div class="ml-2 flex flex-col gap-[2px]">
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg" [class.opacity-20]="isSortedBy('status', sortDirectionEnum.DESC)"/>
                <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg" [class.opacity-20]="isSortedBy('status', sortDirectionEnum.ASC)"/>
            </div>
        </div>
    </div>
</section>

@if (devices.length > 0) {
    <!-- body -->
    <div class="flex flex-col gap-2 mb-6">
        @for (device of currentPageDevices; track $index) {
            <section class="h-[64px] grid grid-cols-7 bg-white rounded-lg justify-items-center py-2 text-neutral-600 text-sm hover:bg-neutral-100">
                <div class="celda-centrada border-r">
                    @if( device.type == deviceTypeEnum.SMARTPOS) {
                        <img class="w-[48px] h-[48px]" src="../../../assets/img/devices/ic-smartpos.svg" />
                    }
                    @else
                    {
                        <img class="w-[48px] h-[48px]" src="../../../assets/img/devices/ic-softpos.svg" />
                    }
                </div>
                <div class="celda-centrada border-r">
                    {{device.merchant_name}}
                </div>
                <div  class="celda-centrada border-r">
                    {{device.alias}}
                </div>
                <div class="celda-centrada border-r">
                    {{device.lsn}}
                </div>
                <div class="celda-centrada border-r">
                    {{device.created_at_time_zone | date:'yyyy-MM-dd HH:mm:ss' }}
                </div>
                <div class="celda-centrada border-r">
                    {{device.updated_at_time_zone | date:'yyyy-MM-dd HH:mm:ss' }}
                </div>
                <div class="celda-centrada">
                    @if (device.status == deviceStatusEnum.ACTIVATED) {
                        <span class="px-3 rounded-full text-[12px] font-semibold bg-success text-white">
                            Habilitado
                        </span>
                    }
                    @else
                    {
                        <span class="px-3 rounded-full text-[12px] font-semibold bg-gray-200 text-neutral-600">
                            Deshabilitado
                        </span>
                    }
                </div>
            </section>
        }
    </div>

    <!-- paginación -->
    <div class="flex items-center justify-end gap-4">
        <!-- Selector de filas por página -->
        <div class="flex items-center space-x-2 text-sm text-gray-600">
            <select [formControl]="pageSizeControl" class="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
            </select>
        </div>
      
        <!-- Controles de paginación -->
        <div class="flex items-center space-x-1">
            <button class="pagination-item" (click)="changePage(currentPage - 1)" [disabled]="currentPage == 0" >
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
            </button>

            @if(paginatedDevice.length > 1) {
                @for (page of paginatedDevice; track $index;) {
                    <button class="pagination-item" [class.pagination-active]="$index == currentPage" (click)="changePage($index)">
                        {{$index + 1 }}
                    </button>
                }
            }
        
            <button class="pagination-item" (click)="changePage(currentPage + 1)" [disabled]="currentPage == (paginatedDevice.length - 1)">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
            </button>
      </div>
    </div>
}

<app-devices-filter
    [(visible)]="showFilter"
    (closeFilter)="closeFilters()"
    (clearFilter)="clearFilter()"
    />